import { LinkBox } from '@doda/common/src/logics/seoFooterLinkData/createSeoFooterLink';
import { LinkList } from './components/LinkList';

/**
 * SeoFooterLink Props
 */
export interface Props {
  /** LinkListのタイトル */
  title: LinkBox['boxName'];
  /** リンクリストのアイテム */
  listItems: LinkBox['boxLinks'];
}

/**
 * SeoFooterLinkはSEOフッターリンクを表示するコンポーネント
 *
 * @param {Props} props - リンクリストのプロパティ
 * @returns {JSX.Element} - SEOフッターリンクの要素
 */
export const SeoFooterLink: React.FC<Props> = ({ title, listItems }) => {
  return <LinkList title={title} listItems={listItems} />;
};
